import { useCallback, useState } from "react";
import { openZegoNativeRealCameraTest } from "../plugins/NativeLivoraCall";
import "./ZegoNativeRealCameraTestButton.css";

export default function ZegoNativeRealCameraTestButton() {
  const [busy, setBusy] = useState(false);

  const handleOpenTest = useCallback(async () => {
    if (busy) {
      return;
    }

    setBusy(true);
    try {
      const result = await openZegoNativeRealCameraTest();
      console.log("[zegoNativeRealCameraTest] result", result);
    } catch (error) {
      console.log("[zegoNativeRealCameraTest] error", String(error?.message || error));
    } finally {
      setBusy(false);
    }
  }, [busy]);

  return (
    <button
      type="button"
      className="zego-native-real-camera-test-btn"
      onClick={handleOpenTest}
      disabled={busy}
      aria-label="Open Zego Native Real Camera Test"
    >
      Open Zego Native Real Camera Test
    </button>
  );
}
